import React, { Fragment } from 'react';
import parse from 'html-react-parser';

import TextBox from '../TextBox';
import Accordion from './Accordion';

const MultiTextBox = ({ item, surveyLanguage }) => {
  const { items: subItems } = item;  
  
  return (
    <div>
      {subItems.map((subItem) => (
        <Fragment key={subItem.id}>
          {subItem.type === 'text-box' && (
            <TextBox
              content={parse(
                subItem.richText?.[surveyLanguage.code] ||
                  subItem.content[surveyLanguage.code]
              )}
            />
          )}
          {subItem.type === 'accordion' && (
            <Accordion
              item={subItem}
              surveyLanguage={surveyLanguage}
            />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default MultiTextBox;
